<template>
  <div class="hris-page">
    <div class="hris-page-inner">
      <div class="hris-page-header">
        <span class="hris-page-eyebrow">Payroll Settings</span>
        <h1 class="hris-page-title">Government Deduction Schedule</h1>
        <p class="hris-page-subtitle">Choose when your company deducts SSS, PhilHealth, and withholding tax. Statutory rates remain global.</p>
      </div>

      <q-form class="hris-panel q-pa-md q-gutter-md" @submit="save">
        <q-select outlined dense color="green" v-model="settings.sss_cutoff" :options="options" emit-value map-options label="SSS deduction cutoff" :disable="!canEdit" />
        <q-select outlined dense color="green" v-model="settings.philhealth_cutoff" :options="options" emit-value map-options label="PhilHealth deduction cutoff" :disable="!canEdit" />
        <q-select outlined dense color="green" v-model="settings.tax_cutoff" :options="options" emit-value map-options label="Withholding tax deduction cutoff" :disable="!canEdit" />
        <div v-if="canEdit" class="hris-modal-footer" style="padding: 0; border-top: none; background: transparent;">
          <q-btn unelevated class="hris-q-primary" label="Save schedule" type="submit" :loading="saving" />
        </div>
        <p v-else class="text-grey-7 q-mb-none">Only company administrators can change this schedule.</p>
      </q-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import mixins from '../../mixins'

export default {
  name: 'GovernmentDeductionSchedule',
  mixins: [mixins],
  data () {
    return {
      saving: false,
      options: [
        { label: 'First cutoff', value: 'FIRST' },
        { label: 'Second cutoff', value: 'SECOND' },
        { label: 'Both cutoffs', value: 'BOTH' }
      ],
      settings: { sss_cutoff: 'BOTH', philhealth_cutoff: 'BOTH', tax_cutoff: 'BOTH' }
    }
  },
  computed: {
    canEdit () {
      const roleId = Number((this.userData || {}).role_id)
      return roleId === 0 || roleId === 1
    }
  },
  created () {
    this.load()
  },
  methods: {
    client () {
      return axios.create({ baseURL: this.apiUrl, headers: { Authorization: `Bearer ${this.token}` } })
    },
    load () {
      this.client().get('/backend/government-deduction-settings').then((res) => {
        this.settings = Object.assign(this.settings, res.data.data || {})
      })
    },
    save () {
      this.saving = true
      const formData = new FormData()
      formData.append('sss_cutoff', this.settings.sss_cutoff)
      formData.append('philhealth_cutoff', this.settings.philhealth_cutoff)
      formData.append('tax_cutoff', this.settings.tax_cutoff)
      this.client().post('/backend/government-deduction-settings', formData).then(() => {
        this.$q.notify({ color: 'green-9', textColor: 'white', message: 'Government deduction schedule saved.' })
      }).finally(() => { this.saving = false })
    }
  }
}
</script>
